import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Body,
  Subhead,
} from "@growtherapy/sprout-ui";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useVisitorConnectRoomCallback } from "./admission/useVisitorConnectRoomCallback";
import { isAdmissionModalOpenAtom } from "./admission/state";
import { useOpenVisitorModalCallback } from "../modals/useOpenVisitorModalCallback";
import { useAdmissionTrackingEvents } from "./admission/useAdmissionTrackingEvents";
import { VisitorState, visitorStateAtom } from "../state";

const HEADING_CONTENT = "Time to join your session";

export function AdmissionModal({
  isOpen,
  onJoin: handleJoin,
  onDismiss: handleDismiss,
  isLoading,
}: {
  isOpen: boolean;
  onJoin: () => void;
  onDismiss: () => void;
  isLoading: boolean;
}) {
  return (
    <Modal
      className="sm:mt-[10%]"
      isOpen={isOpen}
      onClose={isLoading ? undefined : handleDismiss}
    >
      {/* Empty header provides the "X" close button */}
      <ModalHeader className="rebrand:h-0 rebrand:relative rebrand:top-200">
        <span />
      </ModalHeader>
      <ModalBody className="flex flex-col gap-2 items-center">
        <Subhead.Large>{HEADING_CONTENT}</Subhead.Large>
        <Body.Default>Your provider is ready for you!</Body.Default>
      </ModalBody>
      <ModalFooter
        className="flex justify-center"
        actions={[
          {
            key: "join-session",
            "aria-label": isLoading ? "Joining session" : "Join session",
            use: "primary",
            loading: isLoading,
            onClick: handleJoin,
            actionContent: "Join session",
          },
        ]}
      />
    </Modal>
  );
}

export function AdmissionModalWrapper() {
  const isOpen = useAtomValue(isAdmissionModalOpenAtom);
  const connectRoom = useVisitorConnectRoomCallback();
  const isLoading = useAtomValue(visitorStateAtom) === VisitorState.JOINING;
  const openVisitorModal = useOpenVisitorModalCallback();
  const {
    trackAdmissionPromptViewed,
    trackJoinSessionClicked,
    trackAdmissionPromptDismissed,
  } = useAdmissionTrackingEvents();

  useEffect(
    function handleTrackingAdmissionPromptViewed() {
      if (isOpen) {
        trackAdmissionPromptViewed();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen],
  );

  return (
    <AdmissionModal
      isOpen={isOpen}
      onJoin={() => {
        trackJoinSessionClicked();
        connectRoom();
      }}
      onDismiss={() => {
        trackAdmissionPromptDismissed();
        openVisitorModal(null);
      }}
      isLoading={isLoading}
    />
  );
}
